/* eslint complexity: off */

import { history as historyRouter } from 'instantsearch.js/es/lib/routers';
import type { UiState } from 'instantsearch.js';
import { algoliaAttributes } from 'assets/constants';
import cloneDeep from 'lodash/cloneDeep';
import { sanitizeString } from "helpers";

const decodeParamValue = (value: string) => decodeURIComponent(value.replace(/\+/g, ' '));

type RouteState = {
  query?: string;
  page?: string;
  geopage?: string;
  medicalFieldName?: string[];
  subMedicalFieldNames?: string[];
  typeOfDoctor?: string | undefined | null;
  gender?: string[];
  workday?: string[];
  times?: string[];
  lang?: string[];
  city?: string[];
  cityCode?: string[];
  fullName?: string[];
  sortBy?: string;
  loc?: string | undefined | null;
  r?: number | "all" | undefined;
  geo?: string | undefined | null;  // ✅ הוסף שורה זו

};

const routeStateDefaultValues: RouteState = {
  query: '',
  page: '1',
  geopage: '1',
  medicalFieldName: undefined,
  subMedicalFieldNames: undefined,
  typeOfDoctor: "LeumitDoctor",
  gender: undefined,
  workday: undefined,
  times: undefined,
  lang: undefined,
  city: undefined,
  cityCode: undefined,
  fullName: undefined,
  sortBy: 'instant_search',
  loc: undefined,
  r: 10000,
  geo: undefined,
};
const router = historyRouter<RouteState>({

  createURL({ qsModule, routeState, location }): string {
    const { protocol, hostname, port = '', pathname, hash } = location;
    const portWithPrefix = port === '' ? '' : `:${port}`;
    const baseUrl = `${protocol}//${hostname}${portWithPrefix}${pathname}`;
    //const existingQuery = qsModule.parse(location.search.slice(1));

    const queryParameters: Partial<RouteState> = {    };

    if (routeState.query && routeState.query !== routeStateDefaultValues.query) {
      queryParameters.query = encodeURIComponent(routeState.query);
    }
    if (routeState.page && routeState.page !== routeStateDefaultValues.page) {
      queryParameters.page = routeState.page;
    }
    if (routeState.geopage && routeState.geopage !== routeStateDefaultValues.geopage) {
      queryParameters.geopage = routeState.geopage;
    }
    if (routeState.medicalFieldName &&routeState.medicalFieldName !== routeStateDefaultValues.medicalFieldName) {
      queryParameters.medicalFieldName = routeState.medicalFieldName;
    }
    const existingQueryParameters = qsModule.parse(location.search.slice(1));
    const existingSubMedicalFieldNames = Array.isArray(existingQueryParameters.subMedicalFieldNames)
      ? existingQueryParameters.subMedicalFieldNames.filter(Boolean)
      : existingQueryParameters.subMedicalFieldNames
        ? [existingQueryParameters.subMedicalFieldNames]
        : [];
    const existingTypeOfDoctor = typeof existingQueryParameters.typeOfDoctor === 'string'
      ? existingQueryParameters.typeOfDoctor
      : undefined;

    if (
      routeState.subMedicalFieldNames &&
      routeState.subMedicalFieldNames !== routeStateDefaultValues.subMedicalFieldNames
    ) {
      queryParameters.subMedicalFieldNames = routeState.subMedicalFieldNames;
    } else if (existingSubMedicalFieldNames.length > 0) {
      queryParameters.subMedicalFieldNames = existingSubMedicalFieldNames as string[];
    }
    if (
      routeState.typeOfDoctor &&
      routeState.typeOfDoctor !== routeStateDefaultValues.typeOfDoctor
    ) {
      queryParameters.typeOfDoctor = routeState.typeOfDoctor;
    } else if (!routeState.typeOfDoctor && existingTypeOfDoctor === 'ExternalDoctor') {
      queryParameters.typeOfDoctor = existingTypeOfDoctor;
    }
    if (
      routeState.gender &&
      routeState.gender !== routeStateDefaultValues.gender
    ) {
      queryParameters.gender = routeState.gender.map(encodeURIComponent);
    }

    if (
      routeState.workday &&
      routeState.workday !== routeStateDefaultValues.workday
    ) {
      queryParameters.workday = routeState.workday.map(encodeURIComponent);
    }

    if (routeState.fullName && routeState.fullName !== routeStateDefaultValues.fullName) {
      queryParameters.fullName = routeState.fullName.map(encodeURIComponent);
    }

    if (
      routeState.times &&
      routeState.times !== routeStateDefaultValues.times
    ) {
      queryParameters.times = routeState.times.map(encodeURIComponent);
    }

    if (
      routeState.lang &&
      routeState.lang !== routeStateDefaultValues.lang
    ) {
      queryParameters.lang = routeState.lang.map(encodeURIComponent);
    }

    if (routeState.city &&routeState.city !== routeStateDefaultValues.city) {
      queryParameters.city = routeState.city.map(encodeURIComponent);
    }

    if (routeState.cityCode &&routeState.cityCode !== routeStateDefaultValues.cityCode) {
      queryParameters.cityCode = routeState.cityCode;
    }

    if (!routeState.sortBy || routeState.sortBy === routeStateDefaultValues.sortBy) {
      delete (queryParameters as any).sortBy;
    } else {
      queryParameters.sortBy = routeState.sortBy;
    }
    if (routeState.loc &&routeState.loc !== routeStateDefaultValues.loc) {
      queryParameters.loc = routeState.loc;
      queryParameters.r = routeState.r;
      queryParameters.geo = '1'; 
    }
    else {
      delete (queryParameters as any).loc;
      delete (queryParameters as any).r;
      delete (queryParameters as any).geo;
    }
    

    const queryString = qsModule.stringify(queryParameters, {
      addQueryPrefix: true,
      arrayFormat: 'repeat',
    });

    return `${baseUrl}${queryString}${hash}`;
  },

  parseURL({ qsModule, location }): RouteState {
    const queryParameters = qsModule.parse(location.search.slice(1));
    const {
      query = '',
      page = 1,
      geopage = 1,
      medicalFieldName,
      subMedicalFieldNames,
      typeOfDoctor,
      gender,
      workday,
      times,
      lang,
      city,
      cityCode,
      fullName,
      sortBy,
      loc,
      r,
      geo  
    } = queryParameters;

    const allgender = (
      Array.isArray(gender) ? gender : [gender].filter(Boolean)
    ) as string[];

    const allcityCode = (
      Array.isArray(cityCode) ? cityCode : [cityCode].filter(Boolean)
    ) as string[];

    const allfullName = (
      Array.isArray(fullName) ? fullName : [fullName].filter(Boolean)
    ) as string[];

    const allmedicalFieldName = (
      Array.isArray(medicalFieldName) ? medicalFieldName : [medicalFieldName].filter(Boolean)
    ) as string[];

    const allsubMedicalFieldName = (
      Array.isArray(subMedicalFieldNames) ? subMedicalFieldNames : [subMedicalFieldNames].filter(Boolean)
    ) as string[];

    const allworkday = (
      Array.isArray(workday) ? workday : [workday].filter(Boolean)
    ) as string[];

    const alltimes = (
      Array.isArray(times) ? times : [times].filter(Boolean)
    ) as string[];

    const alllang = (
      Array.isArray(lang) ? lang : [lang].filter(Boolean)
    ) as string[];

    const allcities = (
      Array.isArray(city) ? city : [city].filter(Boolean)
    ) as string[];

    return {
      query: decodeParamValue(query as string),
      page: page as string,
      geopage: geopage as string,
      medicalFieldName: allmedicalFieldName.map(decodeParamValue),
      subMedicalFieldNames: allsubMedicalFieldName.map(decodeParamValue),
      typeOfDoctor: typeOfDoctor as string,
      gender: allgender.map(decodeParamValue),
      workday: allworkday.map(decodeParamValue),
      times: alltimes.map(decodeParamValue),
      lang: alllang.map(decodeParamValue),
      city: allcities.map(decodeParamValue),
      cityCode: allcityCode.map(decodeParamValue),
      fullName: allfullName.map(decodeParamValue),
      sortBy: sortBy as string,
      loc: typeof loc === 'string' ? decodeParamValue(loc) : undefined,
      r: r ? parseInt(r as string) : 10000,
      geo: typeof geo === 'string' ? decodeParamValue(geo) : undefined,

    };
  },
});

const getStateMapping = ({ indexName, objectType }: { indexName: string, objectType: any }) => ({
  stateToRoute(uiState: UiState): RouteState {
    const indexUiState = uiState[indexName];
    const exactUiState = uiState['exact'];
    const geoUiState = uiState['geo'];
    //const cityCodesRegex = /medicalCenter\.cityCode:(\d+)/g;
    //const medicalFieldNameRegx = /medicalFieldName:'(.*?)'( |$)/;
    //let cityCodesmatches;
    let aroundRadiusMatches;
    let arroundLatLngMatches;
    let cityCodesMatches;
    //let medicalFieldNameMatches;
    if (geoUiState != undefined) {
      //cityCodesmatches = exactUiState?.configure?.filters?.match(cityCodesRegex);
      //medicalFieldNameMatches = exactUiState?.configure?.filters?.match(medicalFieldNameRegx);
      aroundRadiusMatches = geoUiState?.configure?.aroundRadius;
      arroundLatLngMatches = geoUiState?.configure?.aroundLatLng;
      cityCodesMatches = geoUiState?.refinementList && geoUiState?.refinementList[algoliaAttributes.CityCode];
    }
    else if (exactUiState != undefined) {
      //cityCodesmatches = exactUiState?.configure?.filters?.match(cityCodesRegex);
      //medicalFieldNameMatches = exactUiState?.configure?.filters?.match(medicalFieldNameRegx);
      aroundRadiusMatches = exactUiState?.configure?.aroundRadius;
      arroundLatLngMatches = exactUiState?.configure?.aroundLatLng;
      cityCodesMatches = exactUiState?.refinementList && exactUiState?.refinementList[algoliaAttributes.CityCode];
    }
    else {
      //cityCodesmatches = indexUiState?.configure?.filters?.match(cityCodesRegex);
      //medicalFieldNameMatches = indexUiState?.configure?.filters?.match(medicalFieldNameRegx);
      aroundRadiusMatches = indexUiState?.configure?.aroundRadius;
      arroundLatLngMatches = indexUiState?.configure?.aroundLatLng;
      cityCodesMatches = indexUiState?.refinementList && indexUiState?.refinementList[algoliaAttributes.CityCode];
    }
    //const cityCodes = (cityCodesmatches?.map(match => match.replace("medicalCenter.cityCode:", "")) || []).join(',');
    //const medicalFieldName = (medicalFieldNameMatches?.map(match => match.replace("medicalFieldName:", ""))[1] || ''); 
    return {
      query: indexUiState.query,
      page: (indexUiState.page && String(indexUiState.page)) || undefined,
      geopage: (geoUiState && geoUiState.page && String(geoUiState.page)) || undefined,
      typeOfDoctor: (indexUiState.menu && indexUiState.menu['type']) || undefined,
      gender: indexUiState.refinementList && indexUiState.refinementList[algoliaAttributes.Gender],
      workday: indexUiState.refinementList && indexUiState.refinementList[algoliaAttributes.DaysOfWeek],
      times: indexUiState.refinementList && indexUiState.refinementList[algoliaAttributes.WorkHours],
      lang: indexUiState.refinementList && indexUiState.refinementList[algoliaAttributes.Languages],
      city: indexUiState.refinementList && indexUiState.refinementList['medicalCenter.city'],
      medicalFieldName: indexUiState.refinementList && indexUiState.refinementList[algoliaAttributes.MedicalFieldName],
      subMedicalFieldNames: indexUiState.refinementList && indexUiState.refinementList[algoliaAttributes.SubMdicalFieldName],
      cityCode: cityCodesMatches,
      fullName: indexUiState.refinementList && indexUiState.refinementList[algoliaAttributes.FullName],
      sortBy: indexUiState.sortBy,
      loc: arroundLatLngMatches ? arroundLatLngMatches : undefined,
      r: aroundRadiusMatches ? aroundRadiusMatches : undefined,
      geo: arroundLatLngMatches ? '1' : undefined,

    };
  },

  routeToState(routeState: RouteState): UiState {
    
    const workdays = new URLSearchParams(window.location.search).getAll('workday').map(day => decodeURIComponent(day));
    const times = new URLSearchParams(window.location.search).getAll('times').map(time => decodeURIComponent(time));
    const lang = new URLSearchParams(window.location.search).getAll('lang').map(lang => decodeURIComponent(lang));
    const gender = new URLSearchParams(window.location.search).getAll('gender').map(gender => decodeURIComponent(gender));

    const refinementList: { [key: string]: string[] } = {};
    const menuRefinement: { [key: string]: string } = {};
    let filters: string = '';
    switch (objectType) {
      case 1: filters = 'objectType:Doctor AND '; break;
      case 2: filters = 'objectType:Diet AND '; break;
      case 3: filters = 'objectType:SocialWorker AND '; break;
    }
    let aroundLatLng = undefined;
    let aroundRadius = undefined;
    let configure = {};
    let geoSearch = false;
    let geofilters = '';
    let exactfilters = '';
    let geoconfigure = {};
    let exactconfigure = {};

    if (routeState.typeOfDoctor) {
      menuRefinement['type'] = routeState.typeOfDoctor;
    }
    else {
      menuRefinement['type'] = "LeumitDoctor";
    }

    if (routeState.city) {
      refinementList['medicalCenter.city'] = routeState.city;
    }

    if (routeState.gender && routeState.gender.length) {
      refinementList[algoliaAttributes.Gender] = gender.length > 1 ? gender : sanitizeString(routeState.gender[0]).split(',');
    }

    if (routeState.workday && routeState.workday.length) {
      refinementList[algoliaAttributes.DaysOfWeek] = workdays.length > 1 ? workdays : sanitizeString(routeState.workday[0]).split(',');
    }

    if (routeState.times && routeState.times.length) {
      refinementList[algoliaAttributes.WorkHours] = times.length > 1 ? times : sanitizeString(routeState.times[0]).split(',');
    }

    if (routeState.subMedicalFieldNames && routeState.subMedicalFieldNames.length) {
      refinementList[algoliaAttributes.SubMdicalFieldName] = routeState.subMedicalFieldNames; // sanitizeString(routeState.subMedicalFieldNames[0]).split(',');
    }

    if (routeState.lang && routeState.lang.length) {
      refinementList[algoliaAttributes.Languages] = lang.length > 1 ? lang : sanitizeString(routeState.lang[0]).split(',');
    }

    if (routeState.fullName && routeState.fullName.length) {
      refinementList.fullName = routeState.fullName[0].split(',');
    }

    if (routeState.medicalFieldName?.length) {
      filters += `medicalFieldName:'${(sanitizeString(routeState.medicalFieldName[0]))}'`;     
      refinementList[algoliaAttributes.MedicalFieldName] = routeState.medicalFieldName.map((medicalFieldName) => sanitizeString(medicalFieldName));
    }

    if (routeState.medicalFieldName?.length && routeState.subMedicalFieldNames?.length) {
      const subMedicalFilters = routeState.subMedicalFieldNames.map((subMedicalFieldName) => `subMedicalFieldNames:'${sanitizeString(subMedicalFieldName)}'`);
      filters += ` AND (${subMedicalFilters.join(' OR ')})`;
    }

    if (routeState.loc && routeState.loc !== 'undefined') {
      geoSearch = true;
      aroundLatLng = routeState.loc;
      aroundRadius = routeState.r;
    }

    else {
      geoSearch = false;
    }

    if (routeState.cityCode && routeState.cityCode.length) {

      const urlParams = new URLSearchParams(window.location.search);
      let cityCodes = urlParams.getAll('cityCode');

      // Handle both cases where cityCode is a comma-separated string or multiple values
      if (cityCodes.length === 1 && cityCodes[0].includes(',')) {
        cityCodes = cityCodes[0].split(',');
      }
      //const citiesCodes = cityCodes;//routeState.cityCode[0].split(',');
      const citiesFilter = cityCodes.map((cityCode) => {
        return `medicalCenter.cityCode:${sanitizeString(cityCode)}`;
      });
      

      refinementList[algoliaAttributes.CityCode] = cityCodes;//citiesFilter.map((cityCode) => sanitizeString(cityCode));
      if (geoSearch) {
        exactfilters = geofilters = filters;
        exactfilters += filters && filters.includes('medicalFieldName') ? ` AND ${citiesFilter.join(' OR ')}` : `${citiesFilter.join(' OR ')}`;
        geofilters += filters && filters.includes('medicalFieldName') ? ` AND NOT ${citiesFilter.join(' OR ')}` : `NOT ${citiesFilter.join(' OR ')}`;
      }
      else {
        filters += filters && filters.includes('medicalFieldName') ? ` AND (${citiesFilter.join(' OR ')})` : `(${citiesFilter.join(' OR ')})`;
      }
    }

    if ((filters as string)) {
      configure = { ...configure, filters: filters.includes('medicalFieldName') ? filters : filters.endsWith('AND ') ? (filters.replace('AND', '')) : (filters)};
    }
    if (aroundLatLng) {
      configure = { ...configure, aroundLatLng, aroundRadius };
    }
    if (geofilters) {
      geoconfigure = { ...geoconfigure, filters: (geofilters) };
      exactconfigure = { ...exactconfigure, filters: (exactfilters) };
    }
    if (aroundLatLng) {
      exactconfigure = { ...exactconfigure, aroundLatLng, aroundRadius };
      geoconfigure = { ...geoconfigure, aroundLatLng, aroundRadius, getRankingInfo: true };
    }

    if (geoSearch) {
      //remove the cityCode from the refinementList
      let modifiedRefList = cloneDeep(refinementList);
      delete modifiedRefList[algoliaAttributes.CityCode];
      return {
        [indexName]: {
          query: routeState.query,
          page: Number(routeState.page),
          refinementList: modifiedRefList,
          sortBy: routeState.sortBy,
          configure: configure ? configure : undefined,
          menu: menuRefinement ? menuRefinement : undefined,
        },
        ['exact']: {
          query: routeState.query,
          page: Number(routeState.page),
          refinementList,
          sortBy: routeState.sortBy,
          configure: exactconfigure ? exactconfigure : undefined,
          menu: menuRefinement ? menuRefinement : undefined,
        },
        ['geo']: {
          query: routeState.query,
          page: Number(routeState.geopage),
          refinementList,
          sortBy: routeState.sortBy,
          configure: geoconfigure ? geoconfigure : undefined,
          menu: menuRefinement ? menuRefinement : undefined,
        },
      };
    }
    else {
      return {
        [indexName]: {
          query: routeState.query,
          page: Number(routeState.page),
          refinementList,
          sortBy: routeState.sortBy,
          configure: configure ? configure : undefined,
          menu: menuRefinement ? menuRefinement : undefined,
        }
      };
    }
  },
});

const getRouting = (indexName: string, objectType: any) => ({
  router,
  stateMapping: getStateMapping({ indexName, objectType }),
});

export default getRouting;


